import { Injectable } from '@angular/core';
import { WebsiteSettings } from '@app/core/interfaces/website-settings.interface';
import { MetaTagsInfoInterface } from '@core/interfaces/meta-tags-info.interface';

@Injectable({
  providedIn: 'root'
})
export class MessengerService {

  setMessegeScripts(messege_id: string) {
    const fbCustomerChat = document.createElement('div');
    fbCustomerChat.id = 'fb-customer-chat';
    fbCustomerChat.classList.add('fb-customerchat');
    fbCustomerChat.setAttribute('page_id', `${messege_id}`);
    fbCustomerChat.setAttribute('attribution', 'biz_inbox');
    document.body.appendChild(fbCustomerChat);

    (window as any).fbAsyncInit = function () {
      window['FB'].init({
        xfbml: true,
        version: 'v15.0',
      });
    };

    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      const js: any = d.createElement(s);
      js.id = id;
      js.rel= "lazyload";
      js.src = 'https://connect.facebook.net/pl_PL/sdk/xfbml.customerchat.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

  }

  loadMessenger(websiteSettings: WebsiteSettings | MetaTagsInfoInterface): void {
    if (websiteSettings) {
      if (websiteSettings.messageId && +websiteSettings.messageId.length === 15) {
        this.setMessegeScripts(websiteSettings.messageId);
      }
    }
  }
}


// <!-- Messenger Wtyczka czatu Code -->
//     <div id="fb-root"></div>

//     <!-- Your Wtyczka czatu code -->
//     <div id="fb-customer-chat" class="fb-customerchat">
//     </div>

//     <script>
//       var chatbox = document.getElementById('fb-customer-chat');
//       chatbox.setAttribute("page_id", "625547907645159");
//       chatbox.setAttribute("attribution", "biz_inbox");
//     </script>

//     <!-- Your SDK code -->
//     <script>
//       window.fbAsyncInit = function() {
//         FB.init({
//           xfbml            : true,
//           version          : 'v15.0'
//         });
//       };

//       (function(d, s, id) {
//         var js, fjs = d.getElementsByTagName(s)[0];
//         if (d.getElementById(id)) return;
//         js = d.createElement(s); js.id = id;
//         js.src = 'https://connect.facebook.net/pl_PL/sdk/xfbml.customerchat.js';
//         fjs.parentNode.insertBefore(js, fjs);
//       }(document, 'script', 'facebook-jssdk'));
//     </script>
